import { useState, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import AdminHomePage from "@/pages/AdminHomePage";
import StoresUsersManagement from "@/components/admin/StoresUsersManagement";
import MessagesManagement from "@/components/admin/MessagesManagement";
import ProductsManagement from "@/components/admin/ProductsManagement";
import StoreProductsManagement from "@/components/admin/StoreProductsManagement";
import OfficeBusinessDaysManagement from "@/components/admin/OfficeBusinessDaysManagement";
import DeliverySchedulesManagement from "@/components/admin/DeliverySchedulesManagement";
import OrdersView from "@/components/admin/OrdersView";
import ChangeRequestsPage from "@/pages/ChangeRequestsPage";
import ActionCenter from "@/pages/ActionCenter";
import SeasonalRecommendationsManagement from "@/components/admin/SeasonalRecommendationsManagement";
import CategoriesManagement from "@/components/admin/CategoriesManagement";
import ProductLabelsManagement from "@/components/admin/ProductLabelsManagement";
import DeskCancelCleanup from "@/components/admin/DeskCancelCleanup";
import DeskCustomerImport from "@/components/admin/DeskCustomerImport";
import ArticlesManagement from "@/components/admin/ArticlesManagement";
import UnitGroupsManagement from "@/components/admin/UnitGroupsManagement";
import AdhocLinksManagement from "@/components/admin/AdhocLinksManagement";
import SalesSummary from "@/components/admin/SalesSummary";
import SupportPage from "@/pages/SupportPage";
import {
  Home,
  ListOrdered,
  Building2,
  Package,
  Megaphone,
  Calendar,
  Sparkles,
  ShoppingBag,
  Truck,
  FolderTree,
  ClipboardCheck,
  Tag,
  Newspaper,
  Layers,
  Link2,
  LifeBuoy,
  Eraser,
  UserPlus,
  TrendingUp,
} from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

export default function AdminDashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentView, setCurrentView] = useState("home");

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    if (path && path !== "admin") {
      setCurrentView(path);
    } else {
      setCurrentView("home");
    }
  }, [location]);

  const menuItems = [
    { id: "home", label: "ダッシュボード", path: "/admin", icon: Home },
    { type: "category", label: "発注管理" },
    { id: "action-center", label: "要対応ボックス", path: "/admin/action-center", icon: ClipboardCheck },
    { id: "orders", label: "全発注データ", path: "/admin/orders", icon: ListOrdered },
    { id: "adhoc-links", label: "リストなし紐づけ", path: "/admin/adhoc-links", icon: Link2 },
    { id: "sales-summary", label: "売上集計", path: "/admin/sales-summary", icon: TrendingUp },
    { type: "category", label: "店舗管理" },
    { id: "desk-customer-import", label: "デスクから顧客取込", path: "/admin/desk-customer-import", icon: UserPlus },
    { id: "stores-users", label: "店舗・ログイン管理", path: "/admin/stores-users", icon: Building2 },
    { id: "store-products", label: "店舗別商品設定", path: "/admin/store-products", icon: ShoppingBag },
    { type: "category", label: "商品マスタ" },
    { id: "products", label: "商品管理", path: "/admin/products", icon: Package },
    { id: "unit-groups", label: "単位グループ管理", path: "/admin/unit-groups", icon: Layers },
    { id: "product-labels", label: "表示ラベル管理", path: "/admin/product-labels", icon: Tag },
    { id: "categories", label: "カテゴリ管理", path: "/admin/categories", icon: FolderTree },
    { id: "seasonal-recommendations", label: "季節のおすすめ管理", path: "/admin/seasonal-recommendations", icon: Sparkles },
    { id: "articles", label: "特集・お役立ち情報", path: "/admin/articles", icon: Newspaper },
    { type: "category", label: "設定" },
    { id: "delivery-schedules", label: "配送スケジュール設定", path: "/admin/delivery-schedules", icon: Truck },
    { id: "desk-cancel-cleanup", label: "デスク取消クリーンアップ", path: "/admin/desk-cancel-cleanup", icon: Eraser },
    { id: "office-days", label: "事務所営業日管理", path: "/admin/office-days", icon: Calendar },
    { id: "messages", label: "メッセージ管理", path: "/admin/messages", icon: Megaphone },
    { id: "support", label: "サポート", path: "/admin/support", icon: LifeBuoy },
  ];

  return (
    <DashboardLayout
      title="管理者ダッシュボード"
      menuItems={menuItems}
      currentView={currentView}
      onMenuClick={(item) => navigate(item.path)}
      hideMessageBanner={true}
    >
      <Routes>
        <Route path="/" element={<AdminHomePage />} />
        <Route path="/orders" element={<OrdersView />} />
        <Route path="/action-center" element={<ActionCenter />} />
        <Route path="/change-requests" element={<ChangeRequestsPage />} />
        <Route path="/delivery-schedules" element={<DeliverySchedulesManagement />} />
        <Route path="/desk-cancel-cleanup" element={<DeskCancelCleanup />} />
        <Route path="/desk-customer-import" element={<DeskCustomerImport />} />
        <Route path="/stores-users" element={<StoresUsersManagement />} />
        <Route path="/store-products" element={<StoreProductsManagement />} />
        <Route path="/products" element={<ProductsManagement />} />
        <Route path="/product-labels" element={<ProductLabelsManagement />} />
        <Route path="/categories" element={<CategoriesManagement />} />
        <Route path="/seasonal-recommendations" element={<SeasonalRecommendationsManagement />} />
        <Route path="/articles" element={<ArticlesManagement />} />
        <Route path="/unit-groups" element={<UnitGroupsManagement />} />
        <Route path="/adhoc-links" element={<AdhocLinksManagement />} />
        <Route path="/sales-summary" element={<SalesSummary />} />
        <Route path="/office-days" element={<OfficeBusinessDaysManagement />} />
        <Route path="/messages" element={<MessagesManagement />} />
        <Route path="/support" element={<SupportPage />} />
      </Routes>
    </DashboardLayout>
  );
}